/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsJiraAutomationType from '@jira/spa-apps__project-settings-jira-automation/src/ExportedDefault.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type {
	Location,
	Query,
	Route,
	Match,
	HistoryAction,
} from '@atlassian/react-resource-router';

export const LazyProjectSettingsJiraAutomation: LazyComponent<{
	(props: {
		location: Location;
		query: Query;
		route: Route;
		match: Match;
		action: HistoryAction;
	}): React.JSX.Element;
	displayName: string;
}> = lazyForPaint<typeof ProjectSettingsJiraAutomationType>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-jira-automation", jiraSpaEntry: "async-project-settings-jira-automation" */ '@jira/spa-apps__project-settings-jira-automation/src/ExportedDefault.tsx'
		),
);

const AsyncProjectSettingsJiraAutomation = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsJiraAutomation}
		pageId="project-settings-jira-automation"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsJiraAutomation;
